import React, { Component } from 'react';
import moment from 'moment';
import { Convert } from 'src/helpers';
import styles from './_recentTransactions.module.scss';

class RecentTransactions extends Component {
  render() {
    const { recentTransactions } = this.props;
    return (
      <div className={styles['recent-transactions']}>
        <div className={styles['title']}>Recent Transactions</div>
        <div className={styles['list-box']}>
          {recentTransactions &&
            recentTransactions.length > 0 &&
            recentTransactions.map((data, index) => (
              <div className={styles['list']} key={index}>
                <div className={styles['left']}>
                  {' '}
                  <img src="/images/up-yellow-arrow.svg" alt="up arrow" />
                  {Convert.toCurrencyValue(data?.amount)}
                </div>
                <div className={styles['right']}>
                  {moment(data.createdAt, 'YYYY/MM/DD').format('Do MMMM, YYYY')}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default RecentTransactions;
